import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/config";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="border-t border-line bg-surface px-6 py-28 md:px-12 md:py-40">
      <div className="mx-auto grid max-w-[1600px] items-center gap-16 lg:grid-cols-2">
        <Reveal>
          <div
            className="relative h-[420px] overflow-hidden border border-line md:h-[560px]"
            style={{ clipPath: "polygon(0 0, 100% 0, 100% 92%, 92% 100%, 0 100%)" }}
          >
            <img src={IMAGES.office} alt="The Polemikoi Agency team at work" className="h-full w-full object-cover grayscale" />
            <div className="absolute inset-0 bg-black/40" />
            <p className="absolute bottom-6 left-6 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-400">
              Houston, Texas
            </p>
          </div>
        </Reveal>

        <div>
          <Reveal><Overline>10 — About</Overline></Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white md:text-5xl">
              Built for the <span className="text-zinc-500">modern customer journey</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-8 space-y-6 text-base leading-relaxed text-zinc-400 md:text-lg">
              <p>
                The Polemikoi Agency was created around a simple idea: marketing shouldn&rsquo;t
                exist separately from sales and operations.
              </p>
              <p>
                A campaign is only as valuable as the system behind it. TPA combines creative
                execution, advertising strategy, digital infrastructure, and automation to build
                customer acquisition systems designed around how modern customers actually
                discover, evaluate, and purchase from businesses.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
